import React, { useEffect } from 'react';
import { useGTMPageTracking } from '../Hooks/useGTMTracking';

// Higher-order component to wrap pages with GTM tracking
const withGTMTracking = (WrappedComponent, pageName) => {
  return (props) => {
    useGTMPageTracking();

    return <WrappedComponent {...props} />;
  };
};

// Component to automatically track page views
const GTMPageTracker = ({ children }) => {
  useGTMPageTracking();

  return children;
};

export { withGTMTracking };
export default GTMPageTracker;